import { api } from "../lib";
import { getApiErrorStatus } from "../utils/apiError";

export type SlideTissueSource =
  | "distribution"
  | "scanner"
  | "pathologist_review";
export interface SlideTissueRow {
  id: string;
  caseId: string;
  materialOwnerCaseId: string;
  name: string;
  insufficientTissue: boolean;
  canChange?: boolean;
}
export interface SlideTissueResult {
  slideId: string;
  caseId: string;
  materialOwnerCaseId: string;
  insufficientTissue: boolean;
}
export interface SlideTissueInput {
  source: SlideTissueSource;
  caseId: string;
  slideId: string;
  insufficientTissue: boolean;
}
export const slideInsufficientTissueService = {
  list(source: SlideTissueSource, caseId: string) {
    return api.get<SlideTissueRow[]>(
      `/workflows/slide-tissue/${source}/${caseId}`
    );
  },
  setFlag(input: SlideTissueInput) {
    return api.put<SlideTissueResult>(
      `/workflows/slide-tissue/${input.source}/${input.caseId}/${input.slideId}`,
      { insufficientTissue: input.insufficientTissue }
    );
  },
};
export function slideTissueError(error: unknown): string {
  const status = getApiErrorStatus(error);
  if (status === 401)
    return "Your session expired. Sign in again to change this flag.";
  if (status === 403)
    return "You do not have permission to change this flag here.";
  if (status === 409)
    return "The case changed or is locked. Reopen the case before changing this flag.";
  if (status === 404)
    return "This slide is no longer available in this case. Reopen the case.";
  return "The flag could not be saved. Check your connection and try again.";
}
